import { render, staticRenderFns } from "./PasswordRecoverySupport.vue?vue&type=template&id=e53d0e00&"
import script from "./PasswordRecoverySupport.vue?vue&type=script&lang=js&"
export * from "./PasswordRecoverySupport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports